import React, { useState } from 'react';

import AccountCampaignMenubar from '../components/account-campaign-menubar';
import { useGetCampaignsQuery } from '../endpoints/accounts.endpoints';
import { useGetCompaniesQuery } from 'src/pages/billing/endpoints/billing.endpoints';
import CampaignTable from '../components/campaign-table';

const ManageCampaignsTab: React.FC = () => {
  const [searchParams] = useState(() => new URLSearchParams(window.location.search));
  const defaultSearch = searchParams.get('search') || '';

  const [filter, setFilter] = useState<'attention_needed' | 'all'>('attention_needed');
  const [searchQuery, setSearchQuery] = useState(defaultSearch);
  const { data: campaigns = [], isFetching: isLoading, error, refetch } = useGetCampaignsQuery({});
  const { data: companies = [] } = useGetCompaniesQuery();

  const handleUpdateCampaign = (campaignId: string, field: string, value: any) => {
    refetch();
  };

  return (
    <div className="h-full w-full flex flex-col space-y-4 pt-0 overflow-hidden">
      <div className="flex">
        <AccountCampaignMenubar
          label='Campaigns'
          items={campaigns}
          className='bg-gray-201 text-black rounded-full'
          selectedFilter={filter}
          filterSelect={setFilter}
          searchQuery={searchQuery}
          searchChange={setSearchQuery}
        />
      </div>

      <div className="flex h-full">
        <CampaignTable
          campaigns={campaigns}
          companies={companies}
          onUpdateCampaign={handleUpdateCampaign}
          className='h-full'
          filter={filter}
          isRefreshing={isLoading}
          searchQuery={searchQuery}
        />
      </div>
    </div>
  );
};

export default ManageCampaignsTab;
